import moment from "moment";
import axios from "axios";
import CryptoJS from "crypto-js";
import { useReducer } from "react";
//import { decode } from "jsonwebtoken";
import { createBrowserHistory } from 'history';
import { Toast } from "service/toast";

//export const history = require("history").createBrowserHistory({});

export const history = createBrowserHistory();
/* The above code is creating a browser history object using the createBrowserHistory function. This
object can be used to track and manage the browser's history, allowing for navigation between
different pages or states within a web application. */

let routerCache = {},
  timer;

// common state functionality
const commonReducer = (state, payload) => ({
  ...state,
  ...payload,
});

export const stateReducer = (initialState) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [state, dispatch] = useReducer(commonReducer, initialState);

  const updateState = (payload) => {
    dispatch(payload);
  };

  return [state, updateState];
};

export const logScale = (value) => Math.log10(value + 1);

export const viewDocument = (url) => {
  if (url) {
    window.open(url, "_blank");
  } else {
    Toast({ type: "error", message: "File not Found" });
  }
};

export const getMonth = (month) => {
  switch (month) {
    case "Jan":
      return 0;
    case "Feb":
      return 1;
    case "Mar":
      return 2;
    case "Apr":
      return 3;
    case "May":
      return 4;
    case "Jun":
      return 5;
    case "Jul":
      return 6;
    case "Aug":
      return 7;
    case "Sep":
      return 8;
    case "Oct":
      return 9;
    case "Nov":
      return 10;
    case "Dec":
      return 11;
    default:
      return 1;
  }
};

export const dateDiff = (orderStartDate, orderEndDate = false) => {
  let finalValue;

  let currentDate = moment([
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
  ]);

  let startDate = moment([
    String(orderStartDate).split(",")[0].split(" ")[2],
    getMonth(String(orderStartDate).split(",")[0].split(" ")[1]),
    String(orderStartDate).split("th")[0],
  ]);

  let endDate = moment([
    String(orderEndDate).split(",")[0].split(" ")[2],
    getMonth(String(orderEndDate).split(",")[0].split(" ")[1]),
    String(orderEndDate).split("th")[0],
  ]);

  if (orderEndDate) {
    finalValue = endDate.diff(startDate, "days");
  } else {
    finalValue = currentDate.diff(startDate, "days");
  }

  return finalValue > 1 ? `${finalValue} days` : `${finalValue} day`;
};

export const isGeneralImage = (data) => {
  let urls = [];
  data.items.map((list) => {
    list.imgUrls.map((url) => {
      urls.push(url);
    });
  });
  let isGeneral = urls.some((list) => {
    return String(list).includes("General+New");
  });
  return isGeneral ? "Yes" : "No";
};

export const timeConvert = (time) => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};

export const debounce =
  (func, setLoading, timeout = 800) =>
    (...args) => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        typeof setLoading === "function" && setLoading(true);
        await func(...args);
        typeof setLoading === "function" && setLoading(false);
      }, [timeout]);
    };
export const debounceFunction = (fn, delay) => {
  let timeoutID;
  return (...args) => {
    if (timeoutID) clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};
export const downloadFile = ({ url }) => {
  if (!url) return;

  const aTag = document.createElement("a");
  aTag.href = url;
  aTag.click();
};

export function capitalizeLetter(string) {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getFirstLetter = (value) => {
  if (!value) return;
  if (Array.isArray(value)) {
    const filteredValue = value.filter(Boolean);
    let letter = "",
      lastIndex = value?.length - 1;

    if (filteredValue?.length <= 0) return;
    if (filteredValue[0]) letter += filteredValue[0]?.charAt(0)?.toUpperCase();
    if (lastIndex && filteredValue[lastIndex])
      letter += filteredValue[lastIndex]?.charAt(0)?.toUpperCase();

    return letter;
  }
  return value?.charAt(0).toUpperCase();
};

export const Encrypt = (plainText) => {
  if (!plainText) {
    return plainText;
  }
  try {
    var ciphertext = CryptoJS.AES.encrypt(
      plainText,
      "39ib92v7db292bbwqddhvsi73tw048dbi3h8hf4b9cib49"
    ).toString();

    return ciphertext;
  } catch (e) {
    console.log("Error in encryption", e);
    return plainText;
  }
};

export const getGoogleAdress = async ({ lat, lng }) => {
  try {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${"AIzaSyCPQm-Gl4aIgNuj5v8l_J34EEDfGJtZCbU"}`
    );
    return response;
  } catch (error) {
    console.log("error >> ", error);
    return false;
  }
};

export const pvtAndPublicDesignation = [
  {
    label: "Manager",
    value: "Manager",
  },
  {
    label: "Managing Director",
    value: "Managing Director",
  },
  {
    label: "CEO",
    value: "CEO",
  },
  {
    label: "CFO",
    value: "CFO",
  },
  {
    label: "General Manager",
    value: "General Manager",
  },
  {
    label: "Director",
    value: "Director",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const proprietorDesignation = [
  {
    label: "Manager",
    value: "Manager",
  },
  {
    label: "Proprietor",
    value: "Proprietor",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const parterAndLLPDesignation = [
  {
    label: "Managing Partner",
    value: "Managing Partner",
  },
  {
    label: "Authorized Partner",
    value: "Authorized Partner",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const HUFDesignation = [
  {
    label: "Karta",
    value: "Karta",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const coOperativeAndFPODesignation = [
  {
    label: "Manager",
    value: "Manager",
  },
  {
    label: "CEO",
    value: "CEO",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const Hours = [
  "12",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
];

export const Minutes = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
];

export const Types = ["AM", "PM"];

export const findHour = (start, end) => {
  if (start && end) {
    var startTimeString = start;
    var endTimeString = end;

    // Convert time strings to Date objects (assuming today's date)
    var startDate = new Date("1970-01-01T" + startTimeString + ":00");
    var endDate = new Date("1970-01-01T" + endTimeString + ":00");

    // Calculate the time difference in milliseconds
    var timeDifference = endDate - startDate;

    // Convert time difference to minutes
    var differenceInMinutes = timeDifference / (1000 * 60);
    return differenceInMinutes;
  }
};

//export const decodeJWT = (token) => (token ? decode(token) : token);

// export const numberInput = (event) => {
//   if (!event) return;
//   if (
//     [8, 46, 13].includes(Number(event?.keyCode)) ||
//     (event?.keyCode >= 48 && event?.keyCode <= 57) ||
//     (event?.keyCode >= 96 && event?.keyCode <= 105) ||
//     (event?.keyCode >= 37 && event?.keyCode <= 40)
//   ) {
//     return true;
//   } else {
//     event.preventDefault();
//   }
// };

export const numberInput = (event) => {
  if (event.which === 69) {
    event.preventDefault();
  }
};

export const publicAndPrivate = [
  {
    name: "Pan card",
    type: "Entity PAN card",
    required: true,
    limit: 1,
    typeName: "Entity PAN",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Authorized person PAN",
    type: "Authorized person PAN",
    required: true,
    limit: 1,
    typeName: "Individual PAN card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Authorized person Aadhaar",
    type: "Authorized person Aadhaar",
    required: true,
    limit: 1,
    typeName: "Aadhaar Card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Tax Deduction",
    type: "Tax Deduction A/c Number (TAN) allotted by IT Department.",
    required: false,
    limit: 1,
    typeName: "TAN",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Current Directors List",
    type: "List of current directors",
    required: false,
    limit: 1,
    typeName: "List of Current Directors",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Certificate of Incorporation",
    type: "Certificate of Incorporation.",
    required: false,
    limit: 1,
    typeName: "Certificate of Incorporation",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Memorandum of Association",
    type: "Memorandum of Association",
    required: false,
    limit: 1,
    typeName: "Memorandum of Association",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Articles of Association",
    type: "Articles of Association",
    required: false,
    limit: 1,
    typeName: "Articles of Association",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Gst Return",
    type: "Latest GST return copy",
    required: false,
    limit: 1,
    typeName: "Latest GST Return Copy",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Audited Balanced Sheet",
    type: "Last 2 years audited balance sheet (Should not be more than 2 years old).",
    required: false,
    limit: 2,
    accept: ".pdf",
    typeName: "Last 2 years audited balance sheet",
    documentId: null
  },
  {
    name: "Board Resolution of Person",
    type: "Board  resolution  for  authorized  person  (along  with  PAN  &  Aadhaar  Card  if  the  signing authority is not from the board of directors). Kindly note that authorised person who will sign  the  agreement  can’t  sign  the  board  resolution  it  should  be  signed  by  other director who will authorise the person to sign docs with DigiGrain Solutions Private Limited on behalf of the company",
    required: false,
    limit: 1,
    typeName: "Board Resolution",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "MSME Registeration",
    type: "MSME registration (UAM   Number) / Declaration   in case  client   is not having MSME Registrations",
    required: false,
    limit: 1,
    typeName: "MSME Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "TDS / TCS",
    type: "TDS/TCS Declaration from Customer.",
    required: false,
    limit: 1,
    typeName: "TDS/TCS Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Gst Registeration",
    type: "GST registration copy (Form GST REG-06)",
    required: true,
    limit: 1,
    typeName: "GST Registration copy",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Cancelled Cheque",
    type: "Cancelled cheque.",
    required: false,
    limit: 1,
    typeName: "Cancelled Cheque",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Signature Verification",
    type: "Signature verification letter from banker.",
    required: false,
    limit: 1,
    typeName: "Signature Verification Letter",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Bank Statement",
    type: "Self-attested Bank Statement for a period of not less than Six Months. ",
    required: false,
    limit: 1,
    typeName: "Bank Statement",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Blank Cheque",
    type: "5  (five)  Undated  and  blank  cheques  duly  signed  by  authorised  person  issued  in  favour  of DigiGrain Solutions Private Limited.",
    required: false,
    limit: 5,
    typeName: "5 UDC by Authorized Person",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
];

export const proprietory = [

  {
    name: "Authorized person PAN",
    type: "Entity PAN card",
    required: true,
    limit: 1,
    typeName: "Individual PAN card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Authorized person Aadhaar",
    type: "Authorized person Aadhaar",
    required: false,
    limit: 1,
    typeName: "Aadhaar Card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Address Proof",
    type: "Address proof: APMC registration/ Driving license / office premises registration copy as per shop and establishment act / GST registration copy (Form GST REG-06).",
    required: true,
    limit: 1,
    typeName: "Address Proof",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Tax Deduction",
    type: "Tax Deduction A/c Number (TAN) allotted by IT Department",
    required: false,
    limit: 1,
    typeName: "TAN",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Gst Return",
    type: "Latest GST return copy.",
    required: false,
    limit: 1,
    typeName: "Latest GST Return Copy",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Cancelled Cheque",
    type: "Cancelled Cheque",
    required: false,
    limit: 1,
    typeName: "Cancelled Cheque",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "MSME Registeration",
    type: "MSME registration (UAN   Number) /Declaration  incase client is not having MSME Registrations. ",
    required: false,
    fileDownload: true,
    limit: 1,
    typeName: "MSME Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "TDS / TCS",
    type: "TDS/TCS Declaration from Customer",
    required: false,
    limit: 1,
    typeName: "TDS/TCS Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Bank Statement",
    type: " Self-attested Bank Statement for a period of not less than Six Months (Last 6 months).",
    required: false,
    limit: 1,
    typeName: "Bank Statement",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  // {
  //   name: "Signature Verification",
  //   type: "Signature verification from bank.",
  //   required: false,
  //   limit: 1,
  //   accept: ".pdf,.docs,.xlsx", documentId: null

  // },
  {
    name: "5 Blank Cheque",
    type: "5 Undated and blank cheques duly signed by authorised person issued in favour of “DigiGrain Solutions Private Limited”.",
    required: false,
    limit: 5,
    typeName: "5 UDC by Authorized Person",
    accept: ".pdf,.docs,.xlsx",
    documentId: null

  },
  {
    name: "Audited Balanced Sheet",
    type: "Last 2 years audited balance sheet",
    required: false,
    limit: 2,
    typeName: "Last 2 years audited balance sheet",
    accept: ".pdf",
    documentId: null


  },
];

export const parterAndLLP = [
  {
    name: "Pan card",
    type: "Entity PAN card",
    required: true,
    limit: 1,
    typeName: "Entity PAN",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Authorized person PAN",
    type: "Authorized person PAN",
    required: true,
    limit: 1,
    typeName: "Individual PAN card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Authorized person Aadhaar",
    type: "Authorized person Aadhaar",
    required: true,
    limit: 1,
    typeName: "Aadhaar Card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Tax Deduction",
    type: "Tax Deduction A/c Number (TAN) allotted by IT Department.",
    required: false,
    limit: 1,
    typeName: "TAN",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Partnership Deed",
    type: "Self-attested copy of Partnership deed.",
    required: true,
    limit: 1,
    typeName: "Partnership Deed",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Address Proof",
    type: "Address proof: APMC registration/ Driving license / GST registration copy (Form GST REG-06)",
    required: true,
    limit: 1,
    typeName: "Address Proof",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Gst Return",
    type: "Latest GST return copy (In case of dealing in taxable commodity).",
    required: false,
    limit: 1,
    typeName: "Latest GST Return Copy",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "MSME Registeration",
    type: "MSME registration (UAN Number) / Declaration in case client is not having MSME Registrations.",
    required: false,
    fileDownload: true,
    limit: 1,
    typeName: "MSME Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "TDS / TCS",
    type: "TDS/TCS Declaration from Customer.",
    required: false,
    limit: 1,
    typeName: "TDS/TCS Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Partner Consent Letter",
    type: "Partners Consent Letter signed by all partners.",
    required: true,
    limit: 1,
    typeName: "Partner Concerned Letter",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Cancelled Cheque",
    type: "Cancelled cheque",
    required: false,
    limit: 1,
    typeName: "Cancelled Cheque",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  // {
  //   name: "Signature Verification",
  //   type: "Signature verification from bank",
  //   required: false,
  //   limit: 1,
  //   accept: ".pdf,.docs,.xlsx", documentId: null

  // },
  {
    name: "Bank Statement",
    type: "Self-attested Bank Statement for a period of not less than Six Months.",
    required: false,
    limit: 1,
    typeName: "Bank Statement",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Blank Cheque",
    type: "5  (five)  Undated  and  blank  cheques  duly  signed  by  authorised  person  issued  in  favour  of DigiGrain Solutions Private Limited",
    required: false,
    limit: 5,
    typeName: "5 UDC by Authorized Person",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Audited Balanced Sheet",
    type: "Last 2 years audited Balance Sheet",
    required: false,
    limit: 2,
    typeName: "Last 2 years audited balance sheet",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
];
export const LLP = [
  {
    name: "Pan card",
    type: "Entity PAN card",
    required: true,
    limit: 1,
    typeName: "Entity PAN",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Authorized person PAN",
    type: "Authorized person PAN",
    required: true,
    limit: 1,
    typeName: "Individual PAN card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Authorized person Aadhaar",
    type: "Authorized person Aadhaar",
    required: true,
    limit: 1,
    typeName: "Aadhaar Card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Tax Deduction",
    type: "Tax Deduction A/c Number (TAN) allotted by IT Department.",
    required: false,
    limit: 1,
    typeName: "TAN",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Partnership Deed",
    type: "Self-attested copy of Partnership deed.",
    required: true,
    limit: 1,
    typeName: "Partnership Deed",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Address Proof",
    type: "Address proof: APMC registration/ Driving license / GST registration copy (Form GST REG-06)",
    required: true,
    limit: 1,
    typeName: "Address Proof",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Gst Return",
    type: "Latest GST return copy (In case of dealing in taxable commodity).",
    required: false,
    limit: 1,
    typeName: "Latest GST Return Copy",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "MSME Registeration",
    type: "MSME registration (UAN Number) / Declaration in case client is not having MSME Registrations.",
    required: false,
    fileDownload: true,
    limit: 1,
    typeName: "MSME Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "TDS / TCS",
    type: "TDS/TCS Declaration from Customer.",
    required: false,
    limit: 1,
    typeName: "TDS/TCS Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Partner Consent Letter",
    type: "Partners Consent Letter signed by all partners.",
    required: true,
    limit: 1,
    typeName: "Partner Concerned Letter",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Cancelled Cheque",
    type: "Cancelled cheque",
    required: false,
    limit: 1,
    typeName: "Cancelled Cheque",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  // {
  //   name: "Signature Verification",
  //   type: "Signature verification from bank",
  //   required: false,
  //   limit: 1,
  //   accept: ".pdf,.docs,.xlsx", documentId: null

  // },
  {
    name: "Bank Statement",
    type: "Self-attested Bank Statement for a period of not less than Six Months.",
    required: false,
    limit: 1,
    typeName: "Bank Statement",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Blank Cheque",
    type: "5  (five)  Undated  and  blank  cheques  duly  signed  by  authorised  person  issued  in  favour  of DigiGrain Solutions Private Limited",
    required: false,
    limit: 5,
    typeName: "5 UDC by Authorized Person",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Audited Balanced Sheet",
    type: "Last 2 years audited Balance Sheet",
    required: false,
    limit: 2,
    typeName: "Last 2 years audited balance sheet",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
];

export const HUF = [
  {
    name: "Pan card",
    type: "Entity PAN card",
    required: false,
    limit: 1,
    typeName: "Entity PAN",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Authorized person PAN",
    type: "Authorized person PAN",
    required: false,
    limit: 1,
    typeName: "Individual PAN card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },
  {
    name: "Authorized person Aadhaar",
    type: "Authorized person Aadhaar",
    required: false,
    limit: 1,
    typeName: "Aadhaar Card",
    accept: ".pdf,.docs,.xlsx", documentId: null
  },

  {
    name: "Address Proof",
    type: "Address proof: APMC registration/ Driving license / office premises registration copy as per shop and establishment act / GST registration copy (Form GST REG-06)",
    required: false,
    limit: 1,
    typeName: "Address Proof",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Gst Return",
    type: "Latest GST return copy ",
    required: false,
    limit: 1,
    typeName: "Latest GST Return Copy",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Cancelled Cheque",
    type: "Cancelled cheque",
    required: false,
    limit: 1,
    typeName: "Cancelled Cheque",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  // {
  //   name: "Signature Verification",
  //   type: "Signature verification from bank",
  //   required: false,
  //   limit: 1,
  //   accept: ".pdf,.docs,.xlsx", documentId: null

  // },
  {
    name: "Blank Cheque",
    type: "Undated and blank cheques duly signed by authorised person issued in favour of DigiGrain Solutions Private Limited",
    required: false,
    limit: 1,
    typeName: "UDC duly signed by authorised person",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "MSME Registeration",
    type: "MSME  registration  (UAM   Number) / Declaration   in case  client   is   not having  MSME Registrations.",
    required: false,
    fileDownload: true,
    limit: 1,
    typeName: "MSME Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "TDS / TCS",
    type: "TDS/TCS Declaration from Customer.",
    required: false,
    limit: 1,
    typeName: "TDS/TCS Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Bank Statement",
    type: "Bank statement for a period of not less than Six Months.",
    required: false,
    limit: 1,
    typeName: "Bank Statement",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Blank Cheque",
    type: "5  (five)  Undated  and  blank  cheques  duly  signed  by  authorised  person  issued  in  favour  of DigiGrain Solutions Private Limited",
    required: false,
    limit: 5,
    typeName: "5 UDC by Authorized Person",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Audited Balanced Sheet",
    type: "Last 2 years audited Balance Sheet",
    required: false,
    limit: 2,
    typeName: "Last 2 years audited balance sheet",
    accept: ".pdf,.docs,.xlsx",
    documentId: null

  },
];


export const coOperativeSociety = [
  {
    name: "Society Registeration",
    type: "Certificate of registration of society issued by the Registrar of Co-operative society.",
    required: false,
    limit: 1,
    typeName: "Certificate of registration of society issued by the Registrar of Co-operative society.",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Board Resolution of Person",
    type: "Board resolution for authorized person",
    required: false,
    limit: 1,
    typeName: "Board Resolution",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Pan card",
    type: "Entity PAN card",
    required: false,
    limit: 1,
    typeName: "Entity PAN",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Gst Registeration",
    type: "GST registration copy (Form GST REG-06).",
    required: false,
    limit: 1,
    typeName: "GST Registration copy",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Bank Statement",
    type: "Self-attested Bank Statement for a period of not less than Six Months.",
    required: false,
    limit: 1,
    typeName: "Bank Statement",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "MSME Registeration",
    type: "MSME  registration  (UAM   Number) / Declaration   in case  client   is   not having  MSME Registrations.",
    required: false,
    fileDownload: true,
    limit: 1,
    typeName: "MSME Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "TDS / TCS",
    type: "TDS/TCS Declaration from Customer.",
    required: false,
    limit: 1,
    typeName: "TDS/TCS Declaration",
    accept: ".pdf,.docs,.xlsx", documentId: null

  },
  {
    name: "Blank Cheque",
    type: "5  (five)  Undated  and  blank  cheques  duly  signed  by  authorised  person  issued  in  favour  of DigiGrain Solutions Private Limited",
    required: false,
    limit: 5,
    typeName: "5 UDC by Authorized Person",
    accept: ".pdf,.docs,.xlsx",
    documentId: null

  },
  {
    name: "Audited Balanced Sheet",
    type: "Last 2 years audited Balance Sheet",
    required: false,
    limit: 2,
    typeName: "Last 2 years audited balance sheet",
    accept: ".pdf,.docs,.xlsx",
    documentId: null

  },
];

export const publicAndPrivateWithLoadingAndType = publicAndPrivate?.map(({ type }) => ({
  type,
  loading: false
}));

export const proprietoryWithLoadingAndType = proprietory?.map(({ type }) => ({
  type,
  loading: false
}));

export const parterAndLLPWithLoadingAndType = parterAndLLP?.map(({ type }) => ({
  type,
  loading: false
}));

export const HUFWithLoadingAndType = HUF?.map(({ type }) => ({
  type,
  loading: false
}));

export const coOperativeSocietyWithLoadingAndType = coOperativeSociety?.map(({ type }) => ({
  type,
  loading: false
}));




export function formatNumberByComma(num) {
  if (num === undefined || num === null) {
    return;
  }
  // Remove commas if present
  const cleanedNum = num.toString().replace(/,/g, '');

  if (num.toString() == "1500") {
    return "1,500"
  }
  else {
    const numStr = cleanedNum.toString();
    const [integerPart, fractionalPart] = numStr.split(".");
    const lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);
    const formattedIntegerPart = otherDigits
      ? otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThreeDigits
      : lastThreeDigits;
    return fractionalPart
      ? `${formattedIntegerPart}.${fractionalPart}`
      : formattedIntegerPart;
  }
}

export const getDeviceType = () => {
  const width = window.innerWidth;

  return width <= 768 ? 'mobile' : 'desktop'; 
};


export const generateIntervals = (minValue, maxValue, unit) => {
  const rangeData = {
    minimum: Number(minValue),
    maximum: Number(maxValue),
    to: "to",
  };

  const intervals = [];
  let current = rangeData.minimum;
  let next;

  const bothWholeNumbers =
    Number.isInteger(rangeData.minimum) && Number.isInteger(rangeData.maximum);

  const unitStep = bothWholeNumbers ? 1 : 0.5;

  if (current % 1 === 0) {
    next = current + unitStep;
  } else {
    next = current % 1 < 0.5 ? Math.floor(current) + 0.5 : Math.ceil(current);
  }

  next = Math.min(next, rangeData.maximum);

  intervals.push(
    `${parseFloat(current.toFixed(2))} ${unit} ${rangeData.to} ${parseFloat(
      next.toFixed(2)
    )} ${unit}`
  );

  current = next;

  while (current < rangeData.maximum) {
    next = current + unitStep;
    next = Math.min(next, rangeData.maximum);

    intervals.push(
      `${parseFloat(current.toFixed(2))} ${unit} ${rangeData.to} ${parseFloat(
        next.toFixed(2)
      )} ${unit}`
    );

    current = next;
  }

  if (current < rangeData.maximum) {
    intervals.push(
      `${parseFloat(current.toFixed(2))} ${unit} ${rangeData.to} ${parseFloat(
        rangeData.maximum.toFixed(2)
      )} ${unit}`
    );
  }

  return intervals;
};

export const getQualityDetailsValue = (item) => {
  if (!item || typeof item !== "object") return null;

  const value = item?.value;
  const minValue = parseFloat(item?.minValue) || 0;
  const maxValue = parseFloat(item?.maxValue) || 0;

  let valueData;
  if (value && !maxValue) {
    // Convert value to a string and check if it contains "-"
    const valueStr = value.toString();
    const values = valueStr.includes("-") ? valueStr.split("-") : [valueStr];
    const firstValue = parseFloat(values[0]);
    valueData = firstValue === 0 && values.length > 1 ? values[1] : valueStr;
  } else {
    valueData = minValue === 0 ? `${maxValue}` : `${minValue} - ${maxValue}`;
  }

  return valueData ;
};

  export const calculationBasisOptions = [
    { label: "Daily Peak", value: "daily" },
    { label: "Weekly Peak", value: "weekly" },
    { label: "Fortnightly Peak", value: "fortnightly" },
    { label: "Monthly Peak", value: "monthly" },
  ];

  export const secondaryCommercialOptions = [
    { label: "Rent + Stock Management", value: "rentStock" },
    { label: "Storage Charges", value: "storageCharges" },
  ];

  export const stockManagementChargeTypeOptions = [
    { label: "Fixed", value: "fixed" },
    { label: "Variable", value: "variable" },
    { label: "First fixed, then variable", value: "firstFixedThenVariable" },
    { label: "Whichever is higher", value: "whicheverHigher" },
  ];

 export const lockinOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  export const rentTypeOptions = [
    { label: "Fixed", value: "fixed" },
    { label: "Variable (per sft)", value: "variable" },
    { label: "Zero", value: "zero" },
  ];

  export const gstApplicableOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

export const storageChargeTypes = [
  { label: "MT", value: "mt" },
  { label: "Bag", value: "bag" },
  { label: "Bale", value: "bale" },
];
